const customers = state => state.customers
const isLoading = state => state.loading

export default {
  customers,
  isLoading
}



// WEBPACK FOOTER //
// ./src/store/modules/customers/getters.js